import { Html } from "@react-three/drei";
import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loader = () => {
  return (
    <Html>
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    </Html>
  );
};

export default Loader;
